import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import Button from "components/ui/button/Button";

type DefaultSearchTopicHintProps = {
  onEditClick: () => void;
};

export function DefaultSearchTopicHint({ onEditClick }: DefaultSearchTopicHintProps) {
  return (
    <HintWrapper alignItems="center" justifyContent="space-between" gap={8}>
      <Text color="sysPrimaryDefault" description lineHeight="150%">
        Topic default recommended based on company website.
      </Text>
      <Button
        buttonType="tertiary"
        icon="edit05"
        onClick={onEditClick}
        aria-label="Edit default topic"
      />
    </HintWrapper>
  );
}

const HintWrapper = styled(Flex)(({ theme }) => ({
  backgroundColor: theme.colors.sysPrimarySubtle,
  borderRadius: "4px",
  padding: "8px 12px",
}));
